import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token from localStorage as fallback when cookie can't be sent
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("hexis_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("hexis_token", token);
  else localStorage.removeItem("hexis_token");
}
